import { render, staticRenderFns } from "./Platinum.vue?vue&type=template&id=57cf4431&scoped=true&"
import script from "./Platinum.vue?vue&type=script&lang=js&"
export * from "./Platinum.vue?vue&type=script&lang=js&"
import style0 from "./Platinum.vue?vue&type=style&index=0&id=57cf4431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf4431",
  null
  
)

export default component.exports